import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function Cookies() {
  const contact = siteConfig.contact || {};
  const lastUpdated = siteConfig.policyLastUpdated || "16 October 2026";

  return (
    <main className="content-page legal-page privacy-page">
      <header className="page-hero page-hero--compact">
        <div className="page-shell page-hero__content">
          <p className="eyebrow">Your choices</p>
          <h1>Cookie policy</h1>
          <p className="page-hero__lede">How this site uses browser storage and similar technologies.</p>
          <p className="page-hero__lede">Last updated: {lastUpdated}</p>
        </div>
      </header>
      <section className="page-section page-shell legal-layout">
        <nav className="policy-nav" aria-label="Cookie policy sections">
          <p className="eyebrow">Contents</p>
          <a href="#cookie-overview">Overview</a>
          <a href="#cookie-types">Cookie types</a>
          <a href="#cookie-control">Your controls</a>
          <a href="#cookie-contact">Contact</a>
        </nav>
        <article className="prose legal-copy">
          <section id="cookie-overview">
            <h2>1. Overview</h2>
            <p>Cookies, local storage, and session storage are browser technologies used to keep a site working, remember choices, or measure performance. This storefront currently uses browser storage for shopping functions and does not operate advertising or analytics cookies.</p>
            <p>The current application stores cart items under <code>cartItems</code>, wishlist items under <code>wishlistItems</code>, and a short-lived checkout summary under <code>{siteConfig.checkout?.lastOrderStorageKey || "lastStorefrontOrder"}</code>. These values remain on your device unless your browser clears them; the checkout summary also includes its own short expiry.</p>
          </section>
          <section id="cookie-types">
            <h2>2. Types of cookies</h2>
            <ul>
              <li><strong>Essential and functional storage:</strong> supports cart, wishlist, checkout continuity, security, and requested features.</li>
              <li><strong>Preference storage:</strong> may remember settings you choose for a future visit.</li>
              <li><strong>Analytics technologies:</strong> are not active in this version. If added, they will be described here before use and any consent required by law will be requested.</li>
              <li><strong>Marketing technologies:</strong> are not active in this version. They will not be introduced without the notices and choices required by applicable law.</li>
            </ul>
          </section>
          <section id="cookie-control">
            <h2>3. Your controls</h2>
            <p>You can inspect, clear, or block cookies and site data in your browser settings. Clearing this site's local storage removes the saved cart and wishlist on that device. Blocking essential storage may prevent checkout or saved items from working.</p>
            <p>If optional analytics or marketing tools are introduced, this page and any required consent controls will be updated. Withdrawing optional consent will be as easy as giving it.</p>
            <p>For more about personal information, read our <Link to="/privacy">privacy policy</Link> and <Link to="/security">security policy</Link>.</p>
          </section>
          <section id="cookie-contact">
            <h2>4. Contact</h2>
            <p>Questions about cookies can be sent to <a href={`mailto:${contact.email}`}>{contact.email}</a>.</p>
            {contact.address && <address>{contact.address}</address>}
            <p><Link to="/policies">View all store policies</Link>.</p>
          </section>
        </article>
      </section>
    </main>
  );
}

export default Cookies;
